"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_96_102_0 = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
const SmartPlasticsConfiguration_1 = require("../articles/smartPlastics/SmartPlasticsConfiguration");
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
/**
 * change ArtNr for Ringtrenssteg details see EKE-13294
 */
const migration_96_102_0 = (json) => {
    var _a, _b;
    const ecwSeperator = (_a = json.IAs) === null || _a === void 0 ? void 0 : _a.find((ia) => ia.Artikeltyp === echain_product_models_1.IAArtikeltyp.SmartPlasticsSeparator);
    if (!ecwSeperator)
        return json;
    // delete ecw
    json.IAs = (_b = json.IAs) === null || _b === void 0 ? void 0 : _b.filter((ia) => ia.Artikeltyp !== echain_product_models_1.IAArtikeltyp.SmartPlasticsSeparator);
    const ecwModel = echain_shared_articles_oo_1.IA.fromJson(ecwSeperator).toModel();
    if (json.SmartPlasticsConfiguration) {
        json.SmartPlasticsConfiguration.ECW = { artNr: ecwSeperator.ArtNr, sensor: ecwModel };
    }
    else {
        json.SmartPlasticsConfiguration = {
            ECW: {
                artNr: ecwSeperator.ArtNr,
                sensor: ecwModel,
            },
            switchCabinet: {
                position: echain_shared_igus_fundamentals_1.EchainEnd.fixedEnd,
                distance: { Value: SmartPlasticsConfiguration_1.SWITCH_CABINET_DEFAULT_DISTANCE_M, Unit: echain_prisma_client_1.LengthUnit.m },
            },
        };
    }
    return json;
};
exports.migration_96_102_0 = migration_96_102_0;
//# sourceMappingURL=migration_96_102_0.js.map